import _ from 'lodash'
import security from '@/service/security'
import { IAuthResponse, authResponseToAuthTokens } from '@/plugins/axios'
import router from '@/router'

import {
  isLoggedIn,
  setAuthTokens,
  clearAuthTokens,
  getAccessToken,
  getRefreshToken
} from "axios-jwt";

export default {
  login(store: any, payload: any) {
    clearAuthTokens();
    return security.login(payload)
      .then((resp: IAuthResponse) => {
        store.commit('SET_LOGGED');
        setAuthTokens(authResponseToAuthTokens(resp));
        return true;
      })
      .catch((reason) => {
        store.commit('SET_LOGGED_OUT');
        return _.get(reason, 'response.status', 403);
      });
  },
  logout(store: any) {
    clearAuthTokens();
    router.push({name: 'login'});
    store.commit('SET_LOGGED_OUT');
  }
};
